import { ChevronRight } from '@src/Assets/svg/ChevronRight';
import React from 'react';

interface CategoryItemProps {
  category: string;
  onClick: () => void;
}

export const CategoryItem: React.FC<CategoryItemProps> = ({ category, onClick }) => {
  return (
    <div className="question-state">
      <div className="category-row" onClick={onClick}>
        <span className="category-text">{category} <ChevronRight /></span>
      </div>
    </div>
  );
};
